export default (function (data) { return Math.min.apply(Math, data); });
